import React, { useRef } from "react";
import PropTypes from "prop-types";
import CouponText from "./CouponText";
import CouponToast from "./CouponToast";
import { verifyPublishCoupon } from "../../../app/Helper/CouponHelper";
import { getPopupURL } from "../../../app/Helper/CommonHelper";

/**
 * 쿠폰할인 버튼 컴포넌트
 * - 할인 쿠폰
 * - 슈퍼세이브 할인 쿠폰
 */
function CouponButton({
  title,
  coupons,
  isPartnerDisplay,
  setIsLayerOpen,
  layerOptions,
}) {
  const couponButtonRef = useRef(null);
  const handleClick = () => {
    TMON.sendLog(null, [
      couponButtonRef.current,
      null,
      {
        "tl:area": "DDCM",
        "tl:dimension": `main_deal_srl:${TMON.htStaticData.htDealInfo.dealNo}`,
      },
    ]);

    if (TMON.oApp.sPlatform === "MA") {
      // data parameter 개선을 위해 localstorage 사용
      localStorage.setItem(
        "deal_popup_data",
        JSON.stringify({
          ...layerOptions,
          dealSrls: String(TMON.htStaticData.htDealInfo.dealNo),
        })
      );
      TMON.app.callApp(
        "webview",
        "showView",
        title,
        getPopupURL("coupon"),
        true
      );
    } else {
      setIsLayerOpen(true);
    }
  };

  return (
    <button
      type="button"
      className={`button_coupon ${verifyPublishCoupon(coupons) ? "off" : ""}`}
      aria-label="쿠폰 다운로드"
      onClick={handleClick}
      ref={couponButtonRef}
    >
      <CouponText coupons={coupons} isPartnerDisplay={isPartnerDisplay} />
      <CouponToast />
    </button>
  );
}

CouponButton.propTypes = {
  title: PropTypes.string,
  coupons: PropTypes.shape({}),
  isPartnerDisplay: PropTypes.bool,
  setIsLayerOpen: PropTypes.func,
  layerOptions: PropTypes.shape({}),
};

export default CouponButton;
